import { getMealFlag } from '../helpers/string-format-helper';
import { DiaryType } from '../models/diary-models';

// Os campos são não controlados: o conteúdo de um rascunho entra como defaultValue. Em texto, porque
// o select trata um 0 numérico como vazio.
const withContent = (form: FormParams, content?: DiaryContent): FormParams => {
  if (!content) return form;

  const fill = (item) =>
    item.id && content[item.id] !== undefined && content[item.id] !== null
      ? { ...item, defaultValue: String(content[item.id]) }
      : item;
  const upperFields = form.items.upperFields.map((item) =>
    item.element === 'side' ? { ...item, leftElement: fill(item.leftElement), rightElement: fill(item.rightElement) } : fill(item)
  );

  return { ...form, items: { ...form.items, upperFields } };
};

const emptyForm = (
  type: 'Preschool' | 'Simple'
) => {
  if (type === DiaryType.detailed) {
    return {
      items: {
        upperFields: [
          {
            element: 'side',
            leftElement: {
              element: 'select',
              id: 'sleep',
              label: 'Dormiu:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 0, text: 0 },
                { value: 1, text: 1 },
                { value: 2, text: 2 },
                { value: 3, text: 3 },
                { value: 4, text: 4 },
                { value: 5, text: 5 },
              ],
            },
            rightElement: {
              element: 'select',
              id: 'evacuate',
              label: 'Evacuou:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 0, text: 0 },
                { value: 1, text: 1 },
                { value: 2, text: 2 },
                { value: 3, text: 3 },
                { value: 4, text: 4 },
                { value: 5, text: 5 },
              ],
            },
          },
          {
            element: 'side',
            leftElement: {
              element: 'select',
              id: 'shower',
              label: 'Tomou banho:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 0, text: 0 },
                { value: 1, text: 1 },
                { value: 2, text: 2 },
                { value: 3, text: 3 },
                { value: 4, text: 4 },
                { value: 5, text: 5 },
              ],
            },
            rightElement: {
              element: 'select',
              id: 'diaper',
              label: 'Trocou fralda:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 0, text: 0 },
                { value: 1, text: 1 },
                { value: 2, text: 2 },
                { value: 3, text: 3 },
                { value: 4, text: 4 },
                { value: 5, text: 5 },
              ],
            },
          },
          {
            element: 'subtitle',
            value: 'Nas refeições:',
          },
          {
            element: 'side',
            leftElement: {
              element: 'select',
              id: 'breakfast',
              label: 'Café da manhã:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 'No', text: getMealFlag('No') },
                { value: 'Half', text: getMealFlag('Half') },
                { value: 'Full', text: getMealFlag('Full') },
                { value: 'Repeat', text: getMealFlag('Repeat') },
              ],
            },
            rightElement: {
              element: 'select',
              id: 'afternoonCoffee',
              label: 'Lanche da tarde:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 'No', text: getMealFlag('No') },
                { value: 'Half', text: getMealFlag('Half') },
                { value: 'Full', text: getMealFlag('Full') },
                { value: 'Repeat', text: getMealFlag('Repeat') },
              ],
            },
          },
          {
            element: 'side',
            leftElement: {
              element: 'select',
              id: 'lunch',
              label: 'Almoço:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 'No', text: getMealFlag('No') },
                { value: 'Half', text: getMealFlag('Half') },
                { value: 'Full', text: getMealFlag('Full') },
                { value: 'Repeat', text: getMealFlag('Repeat') },
              ],
            },
            rightElement: {
              element: 'select',
              id: 'dinner',
              label: 'Janta:',
              options: [
                { value: 'default', text: 'Selecionar' },
                { value: 'No', text: getMealFlag('No') },
                { value: 'Half', text: getMealFlag('Half') },
                { value: 'Full', text: getMealFlag('Full') },
                { value: 'Repeat', text: getMealFlag('Repeat') },
              ],
            },
          },
          {
            element: 'textarea',
            id: 'details',
            rows: 5,
            label: 'Observações:',
            placeHolder: 'Descrição do comunicado',
          },
        ],
      },
      style: 'gray',
    } as FormParams;
  } else {
    return {
      items: {
        upperFields: [
          {
            element: 'textarea',
            id: 'details',
            rows: 5,
            label: 'Observações:',
            placeHolder: 'Descrição do comunicado',
          },
        ],
      },
      style: 'gray',
    } as FormParams;
  }
};

export const formDataDiaryCreate = (type: DiaryMode, content?: DiaryContent) =>
  withContent(emptyForm(type), content);
